import exportFromJSON from "export-from-json";

// Spreadsheet apps run cells starting with these characters as formulas (CSV injection).
const FORMULA_PREFIX = /^[=+\-@\t\r]/;
// Plain numbers (e.g. -500, -1,200.50, +966501234567) and a lone "-" placeholder
// can't be formulas, so they are left untouched.
const HARMLESS_VALUE = /^([+-]?[\d,]+(\.\d+)?|-)$/;

export const csvSafe = <T,>(value: T): T | string => {
  if (typeof value !== "string") return value;
  if (FORMULA_PREFIX.test(value) && !HARMLESS_VALUE.test(value)) return `'${value}`;
  return value;
};

const sanitizeRow = (row: unknown) => {
  if (row === null || typeof row !== "object" || Array.isArray(row)) return row;
  return Object.fromEntries(
    Object.entries(row as Record<string, unknown>).map(([key, value]) => [key, csvSafe(value)])
  );
};

type ExportOptions = Parameters<typeof exportFromJSON>[0];

// Drop-in replacement for exportFromJSON that neutralises formula-like values first.
const safeExportFromJSON = (options: ExportOptions) =>
  exportFromJSON({
    ...options,
    data: Array.isArray(options.data) ? options.data.map(sanitizeRow) : options.data,
  });

safeExportFromJSON.types = exportFromJSON.types;

export default safeExportFromJSON;
